module.exports = "/_next/static/images/blankmonitor-duotone-8e03b739c9ab9532ad783dfc98c4a93c.svg";